// extracted by mini-css-extract-plugin
module.exports = {"socialButton":"footer-module--social-button--aUMBQ","socialIcons":"footer-module--social-icons--8YPRX","footerCredits":"footer-module--footer-credits--dpTlw"};